import type { EnvConfigType } from './types'

export { EnvType } from './types'
export type { EnvConfigType } from './types'
/**
 * 通过正则来匹配多种域名, 如: dev2.peerup.com, dev3.peerup.com
 * 由于 new RegExp('dev(\\d+)?.peerup.(cn|com)') 字符串经过转义, 需要"双斜杠"
 */
// const HOST_CONFIG: Record<EnvType, string> = {
//   [EnvType.PROD]: '(www|api)?.peerup.com',
//   /**
//    * beta暂无
//    */
//   [EnvType.BETA]: 'beta.peerup.com',
//   [EnvType.PRE]: 'pre.peerup.com',
//   [EnvType.SIT]: 'sit.peerup.com',
//   [EnvType.SIT1]: 'sit1.peerup.com',
//   [EnvType.DEV]: '(dev(\\d)?.peerup.com|localhost|\\d+\\.\\d+\\.\\d+\\.\\d+)',
// }
// const isClient = typeof window !== 'undefined'

const {
  location: { host: HOST = '' } = {},
} = globalThis
/**
 * 前端当前环境名称
 */
export const env = (globalThis as any)._envsConfig?.VITE_APP_ENV || 'dev'

/**
 * 是否是electron客户端内
 */
export const IS_ELECTRON = globalThis.navigator?.userAgent.toLowerCase().includes('electron')
/**
 * 所有环境通用配置
 */
export const CommonConfig: Pick<
  EnvConfigType,
  | 'VITE_APP_CLIENT'
> = {
  VITE_APP_CLIENT: IS_ELECTRON,
}

export const WS_PROTOCOL = 'wss' // : "ws"

// const PROD_OSS_API = '//peerup-ai-prod.peerup.com'

// const BASIC_OSS_API = '//peerup-ai-basic.oss-cn-beijing.aliyuncs.com'

export const envConfig: EnvConfigType = {
  ...(globalThis as any)._envsConfig,
  ...CommonConfig,
  VITE_APP_DOMAIN_URL: `//${HOST}/`,
  VITE_APP_DOMAIN_URL_WS: `${WS_PROTOCOL}://${HOST}`,
  VITE_APP_NOTE_WS: `${WS_PROTOCOL}://${HOST}`,
  VITE_APP_DOMAIN_HISTORY_WS: `${WS_PROTOCOL}://${HOST}`,
  VITE_APP_DOMAIN_URL_XY: `//xy${HOST}/`,
  VITE_APP_LINK_URL: `//${HOST}/`,
  VITE_APP_HOST_NAME: HOST,
}
